import './header.css'

function HeaderBar(){
    return(
    <header>
        <a href="home" class="logo">Sander Meijer</a>

        <ul>
            <li><a href="home">Projects</a></li>
            <li><a href="#ContactInfo">Contact</a></li>
        </ul>
    </header>
    );
}

export default HeaderBar;